/* eslint-disable no-undef */
import React, { memo } from 'react'
import { MdArrowUpward } from 'react-icons/md'
import styles from './buttonToTop.module.scss'

const ButtonToTop = () => {
  const handleBackToTop = () => {
    const [main] = document.getElementsByTagName('main')
    uss.scrollTo(0, 0, main)
  }

  return (
    <button
      type="button"
      className={styles.backToTop}
      onClick={handleBackToTop}
    >
      <MdArrowUpward size={20} className={styles.backToTopIcon} />
      Voltar ao topo
    </button>
  )
}

export default memo(ButtonToTop)
